import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput, loadingStyle } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import { patternOnlyNumbers } from "../../../../../shared/create-offer/utils/masks";

import SeeMore from "../../shared/SeeMore";
import { useNewOfferMobile } from "../../context";
import { useNewOffer } from "../../../../context/new-offer";
import Loading from "../../../../../shared/create-offer/Loading/Loading";
import ModalForgotPassword from "../../../../../shared/create-offer/ModalForgotPassword/ModalForgotPassword";
import InfoFidelityStep from "./infosSeeMore/InfoFidelityStep";
import Button from "../../../../../shared/button/button";
import { CSSTransition } from "react-transition-group";

// Debounce function
let timerId;
let fnWaiting;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	if (!fn && fnWaiting) fnWaiting();
	fnWaiting = fn;
	if (!fn) return;
	timerId = setTimeout(fn, delay);
};

const PasswordAccess = ({ onChangeLoyalty }) => {
	// Máximo de caracteres para senha da Smiles
	const maxLengthPassSmiles = 4;

	const {
		currentProgram: fidelityProgram,
		loyaltyData,
		userData,
		rankingData,
		twoFactorData,
		request2FACodeLatam,
		setHasClickedRequest2FACode,
		hasClickedRequest2FACode,
		hasTriedToProceedWithout2FA
	} = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		password: loyaltyData.data.password,
		forgotPassword: false,
		hasError: false
	});

	const [debouncing, setDebouncing] = useState(false);

	const shouldShow2FAButton = twoFactorData?.is2FAEnabled;

	const requestTwoFactorCode = async () => {
		setHasClickedRequest2FACode(true);
		await request2FACodeLatam();
	};

	useEffect(() => {
		const password = loyaltyData.data.password;
		const hasError =
			password !== undefined &&
			(fidelityProgram.id === 4
				? password.length !== maxLengthPassSmiles
				: !password.length || password.length < 3);
		setState({
			...state,
			password,
			hasError: !debouncing && hasError
		});

		setStepError(!password || hasError || debouncing);
	}, [loyaltyData.data, debouncing]);

	const onChange = ev => {
		let password = ev.target.value;
		if (fidelityProgram.id === 4) {
			password = ev.target.value.match(patternOnlyNumbers)
				? ev.target.value.match(patternOnlyNumbers).toString()
				: "";
		}
		setDebouncing(true);
		setState({
			...state,
			password
		});
		debounced(() => setDebouncing(false), 1000);
		onChangeLoyalty({ password });
	};

	if (userData.isFetching || rankingData.isFetching) {
		return (
			<div
				className={css`
					${loadingStyle};
				`}
			>
				<Loading width={120} height={120} />
			</div>
		);
	}

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="password"
					id="password"
					type="password"
					autocomplete="off"
					value={state.password}
					inputMode={fidelityProgram.id === 4 ? "tel" : undefined}
					maxLength={50}
					onChange={onChange}
					onBlur={() => debounced(null)}
					placeholder=""
					label="Senha de acesso"
					hasError={state.hasError}
					errorMessage={`Senha inválida. ${
						fidelityProgram.id === 4
							? `A senha de acesso tem ${maxLengthPassSmiles} números.`
							: "O número de caracteres é insuficiente."
					}`}
					helperText={
						<div className="box-fidelity-program-details--forgot-password">
							<a
								onClick={() => setState({ ...state, forgotPassword: true })}
								data-action="forgot-password"
							>
								Esqueci minha senha
							</a>
						</div>
					}
					data-action="login-offer-password"
				/>
			</div>

			{shouldShow2FAButton && (
				<div className="col-xs-16 form-group">
					<Button
						onClick={requestTwoFactorCode}
						disabled={hasClickedRequest2FACode || !state.password}
						className="btn-gray-md-o"
						type="button"
					>
						{twoFactorData.button?.text}
					</Button>
					<CSSTransition
						in={hasClickedRequest2FACode || hasTriedToProceedWithout2FA}
						unmountOnExit
						classNames="box-fidelity-program-details"
					>
						<div className="box-fidelity-program-details">
							<span
								className={
									hasClickedRequest2FACode ? "" : "box-fidelity-program-details--error-message"
								}
							>
								{hasClickedRequest2FACode
									? twoFactorData.helpTextAfterClickButton
									: twoFactorData.helpTextBeforeClickButton}
							</span>
						</div>
					</CSSTransition>
				</div>
			)}

			<InfoFidelityStep acronym={fidelityProgram.fidelityName} fidelityId={fidelityProgram.id} />

			<ModalForgotPassword
				linkPasswordRecovery={fidelityProgram.linkPasswordRecovery}
				show={state.forgotPassword}
				closeModal={() => setState({ ...state, forgotPassword: false })}
			/>
		</div>
	);
};

export default PasswordAccess;
